
import sortOptions from "@/plugins/mixins/sort-options";
import stickyResultsOffset from "@/plugins/mixins/sticky-results-offset";

/**
 * The results heading and the sort control on a single row.
 *
 * Introduced in WFW-6748 for the Wordle and Quordle results pages, which only
 * ever render one result table — the wordlist endpoint fixes `word_length` at
 * 5 and groups by it. Pairing the two saves the vertical space the separate
 * `TableController` row costs, and drops the row's word-count summary, which
 * duplicates the count already in the heading.
 *
 * Intended as the pattern for any single-result-table page, so the sort
 * options come from the shared mixin rather than being hard-coded to the
 * no-score case these two pages happen to be.
 */
export default {
	name: "SingleLengthResultsTableController",
	mixins: [sortOptions, stickyResultsOffset],
	props: {
		/** Rendered as the page's h1. May contain markup. */
		heading: {
			type: String,
			required: true,
		},
		currentSort: {
			type: String,
			required: true,
		},
		tableFields: {
			type: Array,
			required: true,
		},
		usePillsLayout: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		onDropdownSelect(value) {
			this.$emit("change", value);
		},
	},
};
